const JWT_EXPIRATION_TIME_MS = 1000 * 60 * (60 * 3 - 5);

const DICTIONARY_TYPE = {
  NIKE_CUSTOM: 'NIKE_CUSTOM_DICT_CN',
  STOP_WORDS: 'NIKE_STOP_WORDS_CN',
  NOGO: 'NIKE_NOGO_DICT_CN',
};

const TOKENIZER_DIC = {
  NIKE_CUSTOM_DICT_CN: 'Nike Custom Dictionary',
  NIKE_TYPOS_DICT_CN: 'Typo Dictionary',
  NIKE_TAXONOMY_DICT_CN: 'Nike Taxonomy Dictionary',
  NIKE_NOGO_DICT_CN: 'Nike Nogo Dictionary',
};

const QUERY_KEYS = {
  NIKE_CUSTOM_DIC: 'nike-custom-dict',
  STOP_WORDS_DIC: 'stop-words-dict',
  NOGO_DIC: 'nogo-dict',
  ADMIN_USER: 'admin-user',
  ACCESS_TOKEN: 'access-token',
  LABELLING_ALL_DATASET: 'labelling-all-dataset',
  LABELLING_DATASET_PRODUCTS: 'labelling-dataset-products',
  LABELLING_DATASET_PRODUCT_DETAIL: 'labelling-dataset-product-detail',
  LABELLING_DATASET_REPORT: 'labelling-dataset-report',
  NICKNAME_ALL_PRODUCTS: 'nickname-all-products',
  NICKNAME_DICTIONARY: 'nickname-dictionary',
  HOTSEARCH_ALL_RANKING_LISTS: 'hotsearch-all-ranking-lists',
  USER_LIST: '/identity/users/v1',
  ROLE_LIST: '/identity/roles/v1',
  AUDIT_LIST: '/audit/list/v1',
  REWRITE_LIST: 'rewrite-list',
  EXPLAIN_SEARCH_LEGACY: '/explain/search/legacy/v1',
  EXPLAIN_SEARCH_NEW: '/explain/search/new/v1',
  EXPLAIN_SEARCH_NEW_MULTIPATH: '/explain/search/newMultiPath/v1',
  // prettier-ignore
  RECOMMEND_NAV_FILTER: '/proxy/recommend/navigations/v1/product_feed/threads/v2',
  RECOMMEND_CONCEPT_LIST: 'recommend-concepts-list',
  RECOMMEND_CONCEPT_BY_ID: 'recommend-concepts-search-by-id',
  RECOMMEND_CONCEPT_BY_TERMS: 'recommend-concepts-search-by-terms',
  RANKING_RULE_LIST: 'ranking-rule-list',
  SEARCH_SUGGESTIONS: '/proxy/search/suggestions/v1',
  SEARCH_OPTIONS_VERSION: 'search-options-version',
  SEARCH_SELECT_OPTIONS: 'search-select-options',
  RANKING_RULE_PREVIEW_PWALL: 'ranking-rule-preview-pwall',
  OPENSEARCH_INDEX: 'opensearch-index',
  PRODUCT_RANKING: 'product-ranking',
};

const LOCAL_STORAGE_KEY = {
  LOCATION_BEFORE_AUTH: 'search360_location_before_auth',
  USER_JWT: 'USER_JWT',
  USER_JWT_EXPIRE_TS: 'USER_JWT_EXPIRE_TS',
};

const DICTIONARY_TERM_TYPE = {
  MANUAL: 'MANUAL',
  IMPORTED: 'IMPORTED',
};

const REWRITE_TYPE = {
  T2C: 'T2C',
  T2T: 'T2T',
};

const RELATION_TYPE = {
  AND: 'AND',
  OR: 'OR',
};

const REWRITE_T2C_TARGET_SOURCE = '360Rewrite';

const RECOMMEND_CONCEPT_TYPES = [
  'merch/taxonomy_attributes',
  'product_feed/collection_terms',
  'product_feed/dynamic_collections',
  'product_feed/static_collections',
  'catalog/size_conversions',
];

const RANKING_RULE_TARGET_TYPES = {
  STYLE_COLOR: 'STYLE_COLOR',
  STYLE_CODE: 'STYLE_CODE',
  PBID: 'PBID',
  TAXONOMY: 'TAXONOMY',
  PRICE: 'PRICE',
};
const RANKING_RULE_TRIGER_MODE = {
  CASCADE: 'CASCADE',
  EXACT_LOCATION: 'EXACT_LOCATION',
  EXACT: 'EXACT',
  PARTIAL: 'PARTIAL',
};

const PWALL_SORT_OPT_PARAMS = {
  newest: 'effectiveStartViewDateDesc',
  priceDesc: 'productInfo.merchPrice.currentPriceDesc',
  priceAsc: 'productInfo.merchPrice.currentPriceAsc',
};

export {
  JWT_EXPIRATION_TIME_MS,
  DICTIONARY_TYPE,
  DICTIONARY_TERM_TYPE,
  QUERY_KEYS,
  TOKENIZER_DIC,
  REWRITE_TYPE,
  REWRITE_T2C_TARGET_SOURCE,
  LOCAL_STORAGE_KEY,
  RELATION_TYPE,
  RECOMMEND_CONCEPT_TYPES,
  RANKING_RULE_TARGET_TYPES,
  RANKING_RULE_TRIGER_MODE,
  PWALL_SORT_OPT_PARAMS,
};

export const CHANNEL_NAMES: Record<string, string> = {
  '82a74ac1-c527-4470-b7b0-fb5f3ef3c2e2': 'NikeApp',
  '15d92135-394e-487a-8afa-f6c8525c9ea9': 'WeChat',
  'd9a5bc42-4b9c-4976-858a-f159cf99c647': 'Nike.com',
  '008be467-6c78-4079-94f0-70e2d6cc4003': 'SNKRS',
};
